module.exports = __webpack_public_path__ + "img/gena.e63b0a7e.svg";